module.exports = __webpack_public_path__ + "img/6.8cc2e1c8.png";